<div  class="array-box">
    <div class="tool-field">
        <b class="title-field" *ngIf="title!=null">{{title}}</b>
        <div class="spacer"></div>
        <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Adicionar" (click)="addNew()" type="button" *ngIf="showAddButton">
            <nz-icon nzType="plus"></nz-icon>
        </button>
        <span class="space"></span>
    </div>
        <form [formGroup]="formulario" class="form-array">
            <div [formArrayName]="nomeArray" class="display-array">
                <div *ngFor="let formGroup of controles | async;let i = index"  [formGroupName]="filter?selectedIndex:i" (click)="selected(filter?selectedIndex:i)" class="display-formgroup">
                    <div [ngClass]="selectedIndex == i||filter?'display-filegroup-item selected': 'display-filegroup-item'">
                        <div class="display-filegroup-item-components">
                            <div *ngFor="let item of formConfiguration" class="display-filegroup-item-components-lines">
                                <div class="tem-field full" *ngIf="item.type=='string'">
                                    <label class="tem-field-label">{{item.title}}<span class="tem-field-required" *ngIf="item.required"> *</span></label>
                                    <input nz-input type="text"
                                            [name]="item.name"
                                            [formControlName]="item.name"
                                            [placeholder]="item.placeHolder || ''"
                                            nz-tooltip [nzTooltipTitle]="item.tooltip">
                                </div>
                                <div class="tem-field full" *ngIf="item.type=='number'">
                                    <label class="tem-field-label">{{item.title}}<span class="tem-field-required" *ngIf="item.required"> *</span></label>
                                    <input nz-input type="number"
                                            [name]="item.name"
                                            [formControlName]="item.name"
                                            [placeholder]="item.placeHolder || ''"
                                            nz-tooltip [nzTooltipTitle]="item.tooltip">
                                </div>
                                <div class="tem-field full" *ngIf="item.type=='formula'">
                                    <label class="tem-field-label">{{item.title}}<span class="tem-field-required" *ngIf="item.required"> *</span></label>
                                    <nz-input-group [nzSuffix]="suffixFormula">
                                        <input nz-input type="text" #inp
                                                [name]="item.name"
                                                [formControlName]="item.name"
                                                [placeholder]="item.placeHolder || ''"
                                                nz-tooltip [nzTooltipTitle]="item.tooltip">
                                    </nz-input-group>
                                    <ng-template #suffixFormula>
                                        <nz-icon class="suffix-icon" nzType="thunderbolt" (click)="openFormula(inp.value, item.name, formGroup)"></nz-icon>
                                    </ng-template>
                                </div>
                                <div class="tem-field full" *ngIf="item.type=='select'">
                                    <label class="tem-field-label">{{item.title}}<span class="tem-field-required" *ngIf="item.required"> *</span></label>
                                    <nz-select [name]="item.name"
                                                [formControlName]="item.name"
                                                [nzPlaceHolder]="item.placeHolder || item.title"
                                                nzShowSearch
                                                nz-tooltip [nzTooltipTitle]="item.tooltip">
                                        <nz-option *ngFor="let data of item.options" [nzValue]="data.key"
                                            [nzLabel]="item.optionsHideKey == true ? data.value : data.key + ' - ' + data.value"></nz-option>
                                    </nz-select>
                                </div>

                                <div class="toggle-line" *ngIf="item.type=='toggle'" nz-tooltip [nzTooltipTitle]="item.tooltip">
                                    <nz-switch [formControlName]="item.name" nzSize="small"></nz-switch>
                                    <span class="toggle-label">{{item.title}}</span>
                                </div>

                                <div class="tem-field full" *ngIf="item.type=='chips'">
                                    <label class="tem-field-label">{{item.title}}</label>
                                    <nz-select nzMode="tags"
                                        [formControl]="getChipFormControl(selectedIndex,item.name)"
                                        nzPlaceHolder="Novo Valor (chave=valor)..."
                                        [nzTokenSeparators]="[',']">
                                    </nz-select>
                                </div>
                            </div>
                        </div>
                        <span class="space"></span>
                        <div class="action-buttons">
                            <div class="itens-save" *ngIf="showSaveButton">
                                <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Salvar" (click)="save(selectedIndex)" type="button">
                                    <nz-icon nzType="check"></nz-icon>
                                </button>
                            </div>
                            <div class="itens-save" *ngIf="showCancelButton">
                                <button nz-button nzType="primary" nzDanger nzShape="circle" nz-tooltip="Cancelar" (click)="cancel(selectedIndex)" type="button">
                                    <nz-icon nzType="close"></nz-icon>
                                </button>
                            </div>
                            <div class="itens-remove" *ngIf="showRemoveButton">
                                <button nz-button nzShape="circle" nzDanger nz-tooltip="Excluir" (click)="remove(selectedIndex)" type="button">
                                    <nz-icon nzType="delete"></nz-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

</div>
